import { GatewayControleQuinquennal } from "@conformite/gateway";
import { useControleQuinquennal } from "@src/store/store.controleQuinquennal";
import { useEntreprises } from "@src/store/store.entreprise";
import { useCallback, useMemo } from "react";

export const useControlesQuinquennaux = () => {
  const { controlesQuinquennaux } = useControleQuinquennal();
  const { entreprisesBySiren } = useEntreprises();

  const entreprises = useMemo(
    () => Object.values(entreprisesBySiren ?? {}),
    [entreprisesBySiren]
  );
  const getEntreprise = useCallback(
    (controleQuinquennal: GatewayControleQuinquennal.ControleQuinquennal) =>
      entreprises.find(
        (entreprise) =>
          entreprise.hubspotId === controleQuinquennal.idEntreprise
      ),
    [entreprises]
  );
  return {
    controlesQuinquennaux,
    getEntreprise,
  };
};
